"use client"

import {
  cuttingEdgeTechnologyIcon,
  endToEndServicesIcon,
  experiencedDevelopersIcon,
  tailoredSolutionsIcon,
} from '@/assets/icons'
import Card from './ServicesCard'
import { useTranslations } from 'next-intl'

type Props = {
  className: string
}

const ServicesCardsContainer = ({ className }: Props) => {
  const  t  = useTranslations()
  return (
    <div
      className={`${className} relative z-40 grid grid-cols-12 gap-5 px-6 text-center sm:px-14 md:px-8`}
    >
      <Card
        img={experiencedDevelopersIcon}
        title={t('experiencedDevelopers.title')}
        description={t('experiencedDevelopers.description')}
      />
      <Card
        img={tailoredSolutionsIcon}
        title={t('tailoredSolutions.title')}
        description={t('tailoredSolutions.description')}
      />
      <Card
        img={endToEndServicesIcon}
        title={t('endToEndServices.title')}
        description={t('endToEndServices.description')}
      />
      <Card
        img={cuttingEdgeTechnologyIcon}
        title={t('cuttingEdgeTechnology.title')}
        description={t('cuttingEdgeTechnology.description')}
      />
    </div>
  )
}

export default ServicesCardsContainer
